import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseModalService } from '@app/core/services/base-modal.service';

@Directive()
export abstract class BaseModalComponent {

  id!: string;
  title = 'Modal Title';

  @Output() confirm$ = new EventEmitter<boolean>();

  constructor(
    private modalService: BaseModalService,
    public formBuilder: FormBuilder
  ) {}

  @HostListener('document:keydown.escape')
  close(): void {
    this.modalService.close(this.id);
  }

  confirm(): void {
    this.confirm$.emit(true);
  }
}
